import React from "react";
import ErrorBoundary from "./ErrorBoundary";
import { DiffEditor } from "@monaco-editor/react";

const LegacyDiff = ({ currentPublished, newPublish }) => {
  const options = {
    mouseWheelZoom: true,
    smoothScrolling: true,
    colorDecorators: true,
    readOnly: true
  };

  if (currentPublished.error != null) {
    currentPublished = {}
  }

  return (
    <ErrorBoundary>
      <div className="bg-white">
        <DiffEditor
          height="82vh"
          original={JSON.stringify(currentPublished, null, 2)}
          modified={JSON.stringify(newPublish, null, 2)}
          defaultLanguage="json"
          options={options}
        />
      </div>
    </ErrorBoundary>
  );
}

export default LegacyDiff;
